// @ts-strict-ignore

import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  NgZone,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import { LMDrillNavigationService } from '@components/drillaround/lm-drill-navigation.service';
import IdsTree from 'ids-enterprise-wc/components/ids-tree/ids-tree';
import IdsTreeNode, { IdsTreeNodeData } from 'ids-enterprise-wc/components/ids-tree/ids-tree-node';
import 'ids-enterprise-wc/components/ids-icon/ids-icon';
import 'ids-enterprise-wc/components/ids-tree/ids-tree';
import { LMDrillAroundNode } from '@components/drillaround/lm-drill-around-wc';

@Component({
  selector: 'lm-drill-navigation',
  standalone: false,
  templateUrl: './lm-drill-navigation.component.html',
  styleUrls: [ './lm-drill-navigation.component.scss' ],
  providers: [ LMDrillNavigationService ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LMDrillNavigationComponent implements OnInit, AfterViewInit {

  @ViewChild('IDSTree', { read: ElementRef, static: true }) idsTreeElement!: ElementRef;

  /**
   * required to be passed in as input before this.ngOnInit() executes.
   * @required
   */
  @Input() rootDataView!: LMDataView;
  @Input() rootDrillActions!: Array<LMDrillAction>;

  /**
   * This event is fired when a node is selected, the SohoTreeNode
   * selected is passed in the argument passed to the handler.
   * */
  @Output() selected = new EventEmitter<CustomEvent>();

  private selectedDrillAroundNode: LMDrillAroundNode | undefined;

  public idsTree!: IdsTree;

  constructor(
    private ngZone: NgZone,
    private lmDrillNavigationService: LMDrillNavigationService
  ) {}

  ngOnInit(): void {
    this.idsTree = this.idsTreeElement.nativeElement as IdsTree;
    this.idsTree.expandTarget = 'icon'; // need ids-wc ticket to get this fixed
    this.lmDrillNavigationService.setRootDrillRequest(this.rootDataView, this.rootDrillActions);

    this.idsTree.addEventListener('selected', (e: Event) => {
      setTimeout(() => this.onSelected(e as CustomEvent));
    });
  }

  ngAfterViewInit(): void {
    // no-op
    this.initialize();
  }

  private initialize() {
    console.log('initialize');
    this.idsTree.data = this.lmDrillNavigationService.getRootTreeNodes() as IdsTreeNodeData[];

    const rootNodeSelector = '#_root_';
    const parentNodeData: IdsTreeNode | null = this.idsTree.getNode(rootNodeSelector);
    if (!parentNodeData) {
      return;
    }
    const parentNode: LMDrillAroundNode = parentNodeData.data as LMDrillAroundNode;
    if (parentNode?.id) {
      const drillAroundNodes: Array<LMDrillAroundNode> = this.lmDrillNavigationService.buildDrillAroundNodes(
        this.rootDataView, this.rootDrillActions, parentNode);

      parentNode.lmChildren = drillAroundNodes;

      // const selectedId = parentNode.id;
      // drillAroundNodes.forEach(n => {
      //   n.parent = selectedId;
      //   // n.children = n.drillAction?.drillType === 'LIST' ? [] : undefined;
      // });

      this.idsTree.addNodes(drillAroundNodes, 'child', parentNodeData?.elem);
      this.idsTree.select(rootNodeSelector);
    }
  }

  public selectNode(id: string, focus?: boolean): void {
    this.idsTree.select('#' + id);
  }

  get selectedNode(): LMDrillAroundNode | undefined {
    return this.selectedDrillAroundNode;
  }

  set selectedNode(node: LMDrillAroundNode | undefined) {
    if (node?.id) {
      if (node.lmParent) {
        this.expandNode(node.lmParent, false);
      }
      this.selectNode(node.id, true);
    }
  }

  onSelected(selectionEvent: CustomEvent) {
    this.selectedDrillAroundNode = selectionEvent.detail.node.data as LMDrillAroundNode;
    this.selected.emit(selectionEvent);
  }

  // onSelected(selectionEvent: CustomEvent) {
  //   this.selectedDrillAroundNode = selectionEvent.detail.node.data as LMDrillAroundNode;
  //   const drillNavigationEvent: LMDrillNavigationEvent = {
  //     node: selectionEvent.detail.node,
  //     data: selectionEvent.detail.node.data as LMDrillAroundNode
  //   };
  //   this.selected.emit(drillNavigationEvent);
  // }

  // LMTreeNodeSource = (event: SohoTreeEvent,  response: SohoTreeResponseFunction) =>
  //   this.treeNodeSource(event, response);
  //
  // treeNodeSource( event: SohoTreeEvent,  response: SohoTreeResponseFunction ) {
  //   if (event) {
  //     console.log('Event');
  //   }
  //
  //   response = this.treeNodeResponse;
  // }
  //
  // treeNodeResponse( data: SohoTreeNode[] ) {
  //   if (data) {
  //     console.log('Event');
  //   }
  // }
  //
  // onCollapsed(treeEvent: SohoTreeEvent) {
  //   this.selectedDrillAroundNode = treeEvent.data as LMDrillAroundNode;
  // }
  //
  // onExpanded(treeEvent: SohoTreeEvent) {
  //   this.selectedDrillAroundNode = treeEvent.data as LMDrillAroundNode;
  // }

  public addDrillChain(chain: Array<LMDrillAroundDetail>) {
    if (chain && chain.length > 0) {

      // if we find the record node in the tree already
      // lets just use that records, it is the same drillpoint
      const last = chain[chain.length - 1];
      if (last.dataView) {
        const id = this.lmDrillNavigationService.getDrillRecordNodeId(last.dataView.resourceId);

        if (id) {
          this.ngZone.run(() => this.selectNode(id, true));
          return;
        }
      }

      let parentNode: LMDrillAroundNode = this.selectedNode;
      if (parentNode) {
        chain.forEach(item => {
          if (parentNode) {
            let node: LMDrillAroundNode | undefined = undefined;
            if (item.dataView && item.type === 'record') {
              // If already in tree no need to add it again, just move to the next item in chain.
              const foundNode = this.getItemChildNode(parentNode, item.dataView.resourceId);
              if (foundNode) {
                parentNode = foundNode;
                return;
              }

              node = this.lmDrillNavigationService.buildDrillRecordNode(parentNode, item);

            } else if (item.panel && item.panelIndex) {

              // If already in tree no need to add it again, just move to the next item in chain.
              const foundNode = this.getItemChildNode(parentNode, item.panelIndex);
              if (foundNode) {
                parentNode = foundNode;
                return;
              }

              node = this.lmDrillNavigationService.buildDrillPanelNode(parentNode, item);
            }
            if (node) {
              const rootNodeSelector = `#${parentNode.id}`;
              const parentNodeData: IdsTreeNode | null = this.idsTree.getNode(rootNodeSelector);
              if (parentNodeData) {
                this.idsTree.addNodes([ node ], 'child', parentNodeData.elem);
                parentNode = node;
              }
            }
          }
        });

        this.expandNode(parentNode, false);

        if (parentNode?.id) {
          const selectedId = parentNode.id;
          this.ngZone.run(args => this.selectNode(selectedId, true));
        }
      }
    }
  }

  /**
   * Given the parentNode is there a child node that matches the lmKey: either a panel index or a resourceId
   * depending on the node type.
   *
   * @param parentNode The parent node of the child nodes
   * @param lmKey key of the child to look up in the child nodes list
   * @private
   */
  private getItemChildNode(parentNode: LMDrillAroundNode, lmKey: string): LMDrillAroundNode | undefined {
    if (parentNode?.children) {
      const result = parentNode?.children.find(e => e.lmKey === lmKey);
      const foundNode: LMDrillAroundNode = (result as LMDrillAroundNode);
      if (foundNode) {
        return foundNode;
      }
    }
    return undefined;
  }

  /**
   * @deprecated doesn't do anything
   */
  private expandNode(node: LMDrillAroundNode, focus: boolean) {
    // this.idsTree.expand();

    // const tree = this.tree['tree'];
    // const treeNode = node as any;
    //
    // tree.expandNode(treeNode.node, focus);
  }
}
